module.exports = __webpack_public_path__ + "img/Gordijn.18c3f82b.png";